<template>
    <div>
        <az-break-title title="Médicos Solicitantes" />

        <div>
            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb v-if="false">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" @click="copiar()">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button
                        type="button"
                        class="btn btn-outline-success"
                        @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>
        </div>

        <template v-if="!lista || !lista.length">
            <div class="alert alert-info">
                Indicação do código do médico solicitante para esta operadora, quando a operadora não trabalha com CRM para identificação do médico.
            </div>

            <az-empty-state icon="fa-solid fa-user-doctor" msg="Nenhum médico solicitante registrado." />
        </template>

        <div class="list-group mb-3 az-anime-surgir mb-3">
            <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                <span>
                    <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                        {{ dado.search }}
                    </a>
                </span>
                <span class="d-flex">
                    <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                        <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'ativo-' + id"
                        v-model="dado.fl_ativo"
                        @change="toggle(dado)"
                        />
                        <label class="custom-control-label" :for="'ativo-' + id"></label>
                    </div>

                    <div v-else>
                        {{ dado.st_codigo_operadora }}
                    </div>
                </span>
            </li>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="editarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Médico Solicitante {{ item.id_operadora_medico_solicitante ? '#' + item.id_operadora_medico_solicitante : 'Novo' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Médico Solicitante"
                                    placeholder="Solicitante..."
                                    type="autocomplete"
                                    optionsMode="aql"
                                    service="medico_solicitantes.index"
                                    optionsDisplay="search"
                                    optionsData="id_medico_solicitante"
                                    :optionsSync="true"
                                    v-model="item.id_medico_solicitante"
                                    required
                                    :edicao="item.id_operadora_medico_solicitante ? false : true"
                                    :validate="validate">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Código da Operadora"
                                    required
                                    :validate="validate"
                                    v-model="item.st_codigo_operadora" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item && item.id_operadora_medico_solicitante" model="operadoraMedicoSolicitante" :id="item.id_operadora_medico_solicitante" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_operadora_medico_solicitante ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzEmptyState from "../../../util/AzEmptyState.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubmit from "../../../util/AzSubmit.vue";
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            item: null, 
            validate: false, 
            viewMode: "A",
        }
    },

    computed: {
        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(" ", ".*");
                let match = parts;
                let reg = new RegExp(match, "i");

                return this.dados && this.dados.length
                ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                    .filter(item => {
                        return !this.search || reg.test(JSON.stringify(item));
                    })
                : null;
            },
            set(newLista) {
                this.dados = newLista;
            }
        }
    },

    props: ['id_operadora', 'operadoras'],

    components: { 
        AzBreakTitle, 
        AzEmptyState,
        AzInput,
        AzSubmit,
        AzAuditLogButton,
    },

    methods: { 
        copiar() { 
            this.$refs.copiador.copiar();
        },

        incluir() { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = {
                    id_operadora_medico_solicitante: null,
                    st_codigo_operadora: "",
                    id_operadora: this.id_operadora,
                    fl_ativo: true,
                };

                $("#editarModal").modal("show");
            });
        },

        editar(item) { 
            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);
                $('#editarModal').modal('show');
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'operadora_medico_solicitantes',
                parms: { 
                    where: { id_operadora: this.id_operadora },
                }
            });
        },

        toggle(item) {
            this.$util.toggle(this, { 
                service: 'operadora_medico_solicitantes',
                dados: item, 
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'operadora_medico_solicitantes',
                dados: this.item, 
                modal: 'editarModal',
                reload: true, 
            });
        }
    },

    mounted() { 
        this.load(); 
    }

}
</script>